import styled from 'styled-components';
import { motion } from 'framer-motion';

import { fontStyles } from 'theme';

export const Text = styled.p`
  ${({ fontStyle }) => fontStyles[fontStyle]}
  text-align: left;
  color: ${({ $isError }) => ($isError ? 'var(--color-primary)' : 'var(--color-green)')};
`;

export const AnimatedText = styled(motion.div).attrs(({ $timing }) => ({
  animate: {
    opacity: 0,
    height: 0,
    display: 'none',
  },
  transition: {
    opacity: { delay: $timing / 1000, duration: 0.2 },
    height: { delay: $timing / 1000 + 0.2, duration: 0.2 },
    display: { delay: $timing / 1000 + 0.4, duration: 0 },
  },
  initial: {
    opacity: 1,
    height: 'auto',
    display: 'block',
  },
}))`
  ${({ fontStyle }) => fontStyles[fontStyle]}
  text-align: left;
  color: ${({ $isError }) => ($isError ? 'var(--color-primary)' : 'var(--color-green)')};
  opacity: 1;
  height: auto;
  overflow: hidden;
`;
